import React, { useEffect,useState } from "react";
import {Card,Col,Container,Row,CardBody,Label,Button,Form,Input,FormFeedback,Alert,Modal,InputGroup,InputGroupText, ModalHeader} from "reactstrap";
import axios from "axios"
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import { useFormik } from "formik";
import {Link} from 'react-router-dom'
const baseUrl = process.env.REACT_APP_BASE_URL;



const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validatePhone = (phone: string) => {
    const phoneRegex = /^\+?[0-9]{10,15}$/;
    return phoneRegex.test(phone);
};


const validate = (values: any) => {
    const errors: any = {};

    if (!values.firstname) errors.firstname = "First name is required";
    if (!values.lastname) errors.lastname = "Last name is required";

    if (!values.email) {
    errors.email = "Email is required";
    } else if (!validateEmail(values.email)) {
    errors.email = "Invalid email format";
    }

    if (!values.phone) {
    errors.phone = "Phone number is required";
    } else if (!validatePhone(values.phone)) {
    errors.phone = "Enter a valid phone number";
    }

    return errors;
};



const Exp_profile = () => {
document.title = "Update Profile | Skote";



const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; } 
        setAlertMsgg({ ...alertMsgg, open: false }) 
    };
    const [showloader, setshowloader] = useState(true);


  const is_two_fact_status = JSON.parse(localStorage.getItem('enable_two_fact') || 'false')
  console.log("is_two_fact_enable----",is_two_fact_status)
  const [istwofactenable, settwofactenable] = useState(false);
  const [qrImage, setqrImage] = useState<string | null>(null);
  const [otp, setotp] = useState("");
  const [step, setStep] = useState(0);
  const [recoverykey, setrecoverykey] = useState<string[]>([]);
  const [modal_center, setmodal_center] = useState(false);
  const [disableotp, setdisableotp] = useState("");
  const [secretkey, setsecretkey] = useState("");

  const toggletwofactauth = async() => {
    try{
      setshowloader(true);
      const newstatus = !istwofactenable;
      settwofactenable(newstatus);
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      const formdata = new FormData();
      formdata.append("email", user_email)
      const response = await axios.post(`/accounts/two_factor_auth`,formdata,
        {headers :{'Content-Type': 'multipart/form-data'}});
        console.log("twofactorstatus______",response)
        if(response.status === 'UPDATED'){
          const qr = response.qr_code
          setqrImage(qr)
          setStep(1)
          const sec = response.secret
          setsecretkey(sec)
          console.log("SECRET----",response.secret) 
          setshowloader(false);
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error2", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const handleotpchnage = (e) => {
    setotp(e.target.value)
  }
  const verify_two_fact = async() => {
    try{
        if(!otp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
      setshowloader(true)
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      console.log("user_email__2222_",user_email)
      const formData = new FormData();
      formData.append("email", user_email)
      formData.append("otp",otp)
      const response = await axios.post(`accounts/two_factor_verify`,formData,
        {headers :{'Content-Type': 'multipart/form-data'}});
        if(response.status === "VERIFY"){
          const recover = response.recovery_codes
          setrecoverykey(recover);
          localStorage.setItem("enable_two_fact",JSON.stringify(response.enable_two_fact))
          setStep(2);
          setshowloader(false)
          setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error3", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const handlePasswordUpdate = async () => {
        console.log('clicked')
        formik.setErrors({});
        const errors: any = {};
        
        const { currentPassword, newPassword, confirmPassword } = formik.values;
        // Reset previous errors
        // Required fields
        if (!currentPassword) errors.currentPassword = "Current password is required";
        if (!newPassword) errors.newPassword = "New password is required";
        if (!confirmPassword) errors.confirmPassword = "Confirm password is required";
        // Current vs New
        if (currentPassword && newPassword && currentPassword === newPassword) {
          errors.newPassword = "New password cannot be same as current password";
        }
        // New vs Confirm
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
          errors.confirmPassword = "New and confirm passwords do not match";
        }
      
        // Strong password check
        const passwordPattern =
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/;
        if (newPassword && !passwordPattern.test(newPassword)) {
          errors.newPassword =
            "Password must contain at least 6 characters, one uppercase letter, one number, and one special symbol";
        }
    
        // If any errors, set them in Formik and stop
        if (Object.keys(errors).length > 0) {
          formik.setErrors(errors);
          return;
        }
        const data = new FormData();
        data.append("current_password", currentPassword);
        data.append("new_password", newPassword);
        data.append("confirm_Password", confirmPassword);
        data.append("access_token", localStorage.getItem("access_token") || "");
        console.log('currentPassword',currentPassword)
        try {
            setshowloader(true);
            const response = await axios.post("/accounts/change_password", data, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
            });
            console.log('response ka data ',response)
            if (response.status === "success") {
                setAlertMsgg({ ...alertMsgg, open: true, content:"Password updated Sucessfully!", type:"success" });
                setshowloader(false);
                setTimeout(() => {
                setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 4000);
                formik.resetForm();
            }
        } catch (error: any) {
          if (error.response) {
            console.log('error.response',error.response)
            if ([401, 422].includes(error.response.status)) {
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            } else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(() => (window.location.href = "/logout"), 2000);
            } else {
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error4", type: "error" });
        }
        setshowloader(false);

        }
      };

  const disableotpchnage = (e) => {
      setdisableotp(e.target.value)
    }

  const verify_disable_otp = async() =>{
    try{
        if(!disableotp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
        setshowloader(true);
        const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
        const formdata = new FormData ;
        formdata.append("email",user_email);
        formdata.append("otp",disableotp);
        const response = await axios.post(`/accounts/disable_two_factor`,formdata,
        {'headers': {'Content-Type' : 'multipart/form-data'}});
        if(response.status === "Deactive"){
            localStorage.removeItem("enable_two_fact");
            setshowloader(false);
            setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
            setTimeout(() =>{
            setAlertMsgg((prev) => ({...prev, open:false}));
            },3000)
            window.location.reload()
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error5", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
}
  




type CategoryType = {
    id: number;
    name: string;
    subcats: SubCategoryType[];
};

type SubCategoryType = {
    id: number;
    name: string;
};
const [previewImage, setPreviewImage] = useState<string | null>(null);
const [previewBusinessLogo, setPreviewBusinessLogo] = useState<string | null>(null);
const [categoryList, setCategoryList] = useState<CategoryType[]>([]);
const [subCategoryList, setSubCategoryList] = useState<SubCategoryType[]>([]);
const [showCurrent, setShowCurrent] = useState(false);
const [showNew, setShowNew] = useState(false);
const [showConfirm, setShowConfirm] = useState(false);
const [stripeConnectStatus, setStripeConnectStatus] = useState<any>(null);
const [isLoadingStripeLink, setIsLoadingStripeLink] = useState(false);

const [custom_details, setcustom_details] = useState<any[]>([]);
const [timezone, setTimeZone] = useState<any[]>([]);
const [timecode, setTimeCode] = useState<any[]>([]);
const [selectedTimezone, setSelectedTimezone] = useState('');
const [selectedCode, setSelectedCode] = useState('');
const [filteredTimezones, setFilteredTimezones] = useState<any[]>([]);

interface FormValues {
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    category: string;
    Subcategory :string;
    currentPassword:string;
    newPassword:string;
    confirmPassword:string;
    image: string | File;
    // Professional Identity & Branding
    business_name: string;
    professional_title: string;
    business_logo: string | File;
    // Credentials & Qualifications
    certifications: string;
    licenses: string;
    education_background: string;
    years_of_experience: string;
    expertise_level: string;
    // Location & Service Areas
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
    service_areas: string;
    // Social Media & Online Presence
    website: string;
    linkedin_url: string;
    facebook_url: string;
    x_url: string;
    instagram_url: string;
    youtube_url: string;
    professional_blog: string;
    portfolio_url: string;
    // Skills & Specializations
    specializations: string;
    languages_spoken: string;
    // Professional Tools
    tools: string;
    // Client Focus & Experience
    client_types: string;
    industry_experience: string;
    // Portfolio & Media
    profile_video: string;
    case_studies: string;
    // Expert Tags
    expert_tags: string;
    // Business Introduction
    business_introduction: string;
    // Business Phone
    buissness_phone: string;
    // Resume
    resume: string | File;
    // Timezone
    timezone: string;
    timecode: string;
}


const formik = useFormik<FormValues>({
    initialValues: {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    image: "",
    category: "",
    Subcategory:"",
    currentPassword:"",
    newPassword:"",
    confirmPassword:"",
    // Professional Identity & Branding
    business_name: "",
    professional_title: "",
    business_logo: "",
    // Credentials & Qualifications
    certifications: "",
    licenses: "",
    education_background: "",
    years_of_experience: "",
    expertise_level: "",
    // Location & Service Areas
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "United States",
    service_areas: "",
    // Social Media & Online Presence
    website: "",
    linkedin_url: "",
    facebook_url: "",
    x_url: "",
    instagram_url: "",
    youtube_url: "",
    professional_blog: "",
    portfolio_url: "",
    // Skills & Specializations
    specializations: "",
    languages_spoken: "",
    // Professional Tools
    tools: "",
    // Client Focus & Experience
    client_types: "",
    industry_experience: "",
    // Portfolio & Media
    profile_video: "",
    case_studies: "",
    // Expert Tags
    expert_tags: "",
    // Business Introduction
    business_introduction: "",
    // Business Phone
    buissness_phone: "",
    // Resume
    resume: "",
    // Timezone
    timezone: "",
    timecode: "",
    },validate,
    onSubmit: async (values) => {
    const { firstname, lastname, email, phone, image, category, Subcategory } = values;

    if (!firstname || !lastname || !email || !phone || !category || !Subcategory) {
        setAlertMsgg({ open: true, content: "Please fill all required fields", type: "error" });
        return;
    }

    const data = new FormData();
    data.append("first_name", firstname);
    data.append("last_name", lastname);
    data.append("email", email);
    data.append("phone", phone);
    data.append("cat", category);
    data.append("subcat", Subcategory);
    
    if (image instanceof File) {
        data.append("profile_pic", image);
    }
    
    // Professional Identity & Branding
    if (values.business_name) data.append("business_name", values.business_name);
    if (values.professional_title) data.append("professional_title", values.professional_title);
    if (values.business_logo instanceof File) {
        data.append("business_logo", values.business_logo);
    }
    if (values.resume instanceof File) {
        data.append("resume", values.resume);
    }
    
    // Credentials & Qualifications
    if (values.certifications) data.append("certifications", values.certifications);
    if (values.licenses) data.append("licenses", values.licenses);
    if (values.education_background) data.append("education_background", values.education_background);
    if (values.years_of_experience) data.append("years_of_experience", values.years_of_experience);
    if (values.expertise_level) data.append("expertise_level", values.expertise_level);
    
    // Location & Service Areas
    if (values.address_line1) data.append("address_line1", values.address_line1);
    if (values.address_line2) data.append("address_line2", values.address_line2);
    if (values.city) data.append("city", values.city);
    if (values.state) data.append("state", values.state);
    if (values.zipcode) data.append("zipcode", values.zipcode);
    if (values.country) data.append("country", values.country);
    if (values.service_areas) data.append("service_areas", values.service_areas);
    
    // Social Media & Online Presence
    if (values.website) data.append("website", values.website);
    if (values.linkedin_url) data.append("linkedin_url", values.linkedin_url);
    if (values.facebook_url) data.append("facebook_url", values.facebook_url);
    if (values.x_url) data.append("x_url", values.x_url);
    if (values.instagram_url) data.append("instagram_url", values.instagram_url);
    if (values.youtube_url) data.append("youtube_url", values.youtube_url);
    if (values.professional_blog) data.append("professional_blog", values.professional_blog);
    if (values.portfolio_url) data.append("portfolio_url", values.portfolio_url);
    
    // Skills & Specializations
    if (values.specializations) data.append("specializations", values.specializations);
    if (values.languages_spoken) data.append("languages_spoken", values.languages_spoken);
    
    // Professional Tools
    if (values.tools) data.append("tools", values.tools);
    
    // Client Focus & Experience
    if (values.client_types) data.append("client_types", values.client_types);
    if (values.industry_experience) data.append("industry_experience", values.industry_experience);
    
    // Portfolio & Media
    if (values.profile_video) data.append("profile_video", values.profile_video);
    if (values.case_studies) data.append("case_studies", values.case_studies);
    
    // Expert Tags
    if (values.expert_tags) data.append("expert_tags", values.expert_tags);
    
    // Business Introduction
    if (values.business_introduction) data.append("business_introduction", values.business_introduction);
    
    // Business Phone
    if (values.buissness_phone) data.append("buissness_phone", values.buissness_phone);

    // Timezone
    if (values.timezone) data.append("timezone", values.timezone);
    if (values.timecode) data.append("timecode", values.timecode);

    try {
        setshowloader(true)
        const res = await axios.post(`/accounts/exp_profileupdate`, data,{
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        console.log('res _________',res)
        if (res.status === "DONE") {
            localStorage.setItem("userdata", JSON.stringify(res.user));
            window.dispatchEvent(new Event("refreshProfile"));
            fetchExpertprofile()
            setAlertMsgg({ ...alertMsgg, open: true, content:"Profile updated successfully!", type:"success" });
            setshowloader(false)
            setTimeout(() => {
                setAlertMsgg(prev => ({ ...prev, open: false }));
            }, 4000);
        }
        else if (res.status === "ierror") {
            console.log("User already exists");
            setAlertMsgg({ ...alertMsgg, open: true, content:"User already exists!", type:"error" });
            setshowloader(false)
            setTimeout(() => {
            setAlertMsgg(prev => ({ ...prev, open: false }));
            }, 4000);
        }
    } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error6", type: "error" });
        }
        setshowloader(false)
    }
    },
});


const handleProfilePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
    formik.setFieldValue("image", file);

    const reader = new FileReader();
    reader.onloadend = (event) => {
        if (typeof event.target?.result === "string") {
            console.log('image ka data _________',event.target.result)
            setPreviewImage(event.target.result);
        }
    };
    reader.readAsDataURL(file);
    }
};

const handleBusinessLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
        formik.setFieldValue("business_logo", file);

        const reader = new FileReader();
        reader.onloadend = (event) => {
            if (typeof event.target?.result === "string") {
                setPreviewBusinessLogo(event.target.result);
            }
        };
        reader.readAsDataURL(file);
    }
};

const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCatName = e.target.value;
    const selectedCategory = categoryList.find(cat => cat.name === selectedCatName);
    
    formik.setFieldValue("category", selectedCatName);
    setSubCategoryList(selectedCategory?.subcats || []);
    formik.setFieldValue("Subcategory", ""); 
};


const fetchExpertprofile  = async () => {
    try {
        setshowloader(true)
        const response = await axios.get(`/accounts/get_expert_settings`,{});
        console.log('response.expert  333 ',response.expert)
        if (response.status === 'SENT' && response.expert) {
            setshowloader(false)
            const userData = response.expert.user;
            setcustom_details(userData);
            // Note: response.userprofile doesn't exist in backend response - removed

            const foundCat = response.categories.find(
                (cat) => cat.name === response.expert?.category?.name
            );
            
            setCategoryList(response.categories);
            setSubCategoryList(foundCat?.subcats || []);

            const expertData = response.expert;
            
            // Set Stripe Connect status
            if (response.expert.stripe_connect) {
                setStripeConnectStatus(response.expert.stripe_connect);
            }
            
            formik.setValues({
                firstname: userData.first_name || "",
                lastname: userData.last_name || "",
                email: userData.email || "",
                phone: userData.phone || "",
                image: userData.profile_pic || "",
                category: expertData.category?.name || "",
                Subcategory: expertData.subcategory?.name || "",
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
                // Professional Identity & Branding
                business_name: expertData.business_name || "",
                professional_title: expertData.professional_title || "",
                business_logo: expertData.business_logo || "",
                // Credentials & Qualifications
                certifications: expertData.certifications || "",
                licenses: expertData.licenses || "",
                education_background: expertData.education_background || "",
                years_of_experience: expertData.years_of_experience?.toString() || "",
                expertise_level: expertData.expertise_level || "",
                // Location & Service Areas
                address_line1: expertData.address_line1 || "",
                address_line2: expertData.address_line2 || "",
                city: expertData.city || "",
                state: expertData.state || "",
                zipcode: expertData.zipcode || "",
                country: expertData.country || "United States",
                service_areas: expertData.service_areas || "",
                // Social Media & Online Presence
                website: expertData.website || "",
                linkedin_url: expertData.linkedin_url || "",
                facebook_url: expertData.facebook_url || "",
                x_url: expertData.x_url || "",
                instagram_url: expertData.instagram_url || "",
                youtube_url: expertData.youtube_url || "",
                professional_blog: expertData.professional_blog || "",
                portfolio_url: expertData.portfolio_url || "",
                // Skills & Specializations
                specializations: expertData.specializations || "",
                languages_spoken: expertData.languages_spoken || "",
                // Professional Tools
                tools: expertData.tools || "",
                // Client Focus & Experience
                client_types: expertData.client_types || "",
                industry_experience: expertData.industry_experience || "",
                // Portfolio & Media
                profile_video: expertData.profile_video || "",
                case_studies: expertData.case_studies || "",
                // Expert Tags
                expert_tags: expertData.expert_tags || "",
                // Business Introduction
                business_introduction: expertData.business_introduction || "",
                // Business Phone
                buissness_phone: expertData.buissness_phone || "",
                // Resume
                resume: expertData.resume || "",
                // Timezone
                timezone: expertData.timezone || "",
                timecode: expertData.country_code || "",
            });
            
            // Set timezone state
            if (expertData.timezone) {
                setSelectedTimezone(expertData.timezone);
            }
            if (expertData.country_code) {
                setSelectedCode(expertData.country_code);
            }
        }
    } catch (error:any) {
        setshowloader(false)
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in expert profile fetch')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error || "Error loading profile", type: "error" });
            }
            else if (error.response.status === 403) {
                console.log('Error expert profile fetch')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
    }
};

const fetch_timezone = async () => {
    try {
        const response = await axios.post(`/accounts/all_timezone`);
        if (response.status === "SENT") {
            const all_timezones = response.all_timezone;
            const timezoneObj = all_timezones.map((item: any, index: number) => ({
                id: index,
                code: item.code,
                country: item.country,
                timezone: item.timezone
            }));
            const codes = [...new Set(all_timezones.map((item: any) => item.code))];

            setTimeZone(timezoneObj);
            setTimeCode(codes);
            setFilteredTimezones(timezoneObj);
        }
    } catch (error: any) {
        console.log('Error fetching timezones:', error);
    }
};

const handleStripeConnectOnboard = async () => {
    try {
        setIsLoadingStripeLink(true);
        const response = await axios.post(`/accounts/create_expert_stripe_connect_link`, {});
        if (response.status === "SENT" && response.onboarding_url) {
            // Redirect to Stripe onboarding link in the same tab
            window.location.href = response.onboarding_url;
        }
    } catch (error:any) {
        setIsLoadingStripeLink(false);
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error || "Error creating Stripe Connect link", type: "error" });
            } else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000);
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Error creating Stripe Connect link", type: "error" });
            }
        } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
    }
};

const syncStripeStatus = async () => {
    try {
        const response = await axios.post(`/accounts/sync_expert_stripe_connect_status`, {});
        if (response.status === "SENT" && response.stripe_connect) {
            setStripeConnectStatus(response.stripe_connect);
            setAlertMsgg({ ...alertMsgg, open: true, content: "Stripe Connect status updated!", type: "success" });
            setTimeout(() => {
                setAlertMsgg((prev) => ({ ...prev, open: false }));
            }, 3000);
        }
    } catch (error:any) {
        console.error("Error syncing Stripe status:", error);
    }
};

useEffect(() => {
    fetchExpertprofile();
    fetch_timezone();
    
    // Check if returning from Stripe onboarding
    const urlParams = new URLSearchParams(window.location.search);
    const stripeReturn = urlParams.get('stripe_return');
    const stripeRefresh = urlParams.get('stripe_refresh');
    
    if (stripeReturn || stripeRefresh) {
        // Sync status after returning from Stripe
        setTimeout(() => {
            syncStripeStatus();
        }, 1000);
        // Clean up URL params
        window.history.replaceState({}, document.title, window.location.pathname);
    }
}, []);

// Filter timezones when code changes
useEffect(() => {
    if (selectedCode && timezone.length > 0) {
        const filtered = timezone.filter((item: any) => item.code === selectedCode);
        setFilteredTimezones(filtered);
    } else if (timezone.length > 0) {
        setFilteredTimezones(timezone);
    }
}, [selectedCode, timezone]);


return (
    <React.Fragment>
        <div className="page-content">
         {alertMsgg.open && (
            <Alert 
                color={alertMsgg.type === "success" ? "success" : "danger"} 
                toggle={handleAlertMsggClose}
                fade={false}
                style={{ fontWeight: "bold" }}
            >
                {alertMsgg.content}
            </Alert>
            )}
        <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
            <Container fluid>
            {/* {alertMsgg.open && (
            <Alert onClose={handleAlertMsggClose} severity={alertMsgg.type} variant="filled">
                {alertMsgg.content}
            </Alert>
            )} */}
            <Card className="rounded-4">
        <CardBody>
            <Row>
            <Col md={12}>
                <Card className="profileCover rounded-4">
                <CardBody>

                </CardBody>
                </Card>
            </Col>
            <Col xl={12}>
                <Card className="bg-transparent">
                <CardBody>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row className="border-bottom mb-4">
                            <Col md={12} className="profileImgSet">
                                <div className="mb-4 text-center position-relative" style={{ display: "inline-block" }}>
                                    <img
                                    src={
                                        previewImage
                                            ? previewImage
                                            : typeof formik.values.image === "string"
                                            ? `${baseUrl}${formik.values.image}`
                                            : defaultUserImg
                                    }
                                    alt="Profile"
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        objectFit: 'cover',
                                        borderRadius: '50%',
                                        border: '2px solid #dee2e6',
                                    }}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null;
                                        e.currentTarget.src = defaultUserImg;
                                    }}
                                    />
                                    <label htmlFor="upload-profile-pic" className="imgFloatPencil">
                                    <i className="bx bxs-pencil"></i>
                                    </label>
                                    <input
                                    type="file"
                                    id="upload-profile-pic"
                                    accept="image/*"
                                    onChange={(e) => handleProfilePicChange(e)}
                                    style={{ display: 'none' }}
                                    />
                                </div>
                                <p className="mb-0 font-size-18 fw-medium">{formik.values.firstname} {formik.values.lastname}</p>
                                <p className="mb-0 font-size-15">{formik.values.email}</p>
                            </Col>
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Personal Info</p>
                                <p>You can change your personal information setting here.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                    <Row>
                                    <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="firstname">First Name<span className="text-danger px-1">*</span></Label>
                                    <Input
                                    type="text"
                                    name="firstname"
                                    id="firstname"
                                    placeholder="Enter your first name"
                                    value={formik.values.firstname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.firstname && !!formik.errors.firstname}
                                    />
                                    <FormFeedback>{formik.errors.firstname}</FormFeedback>
                                </div>
                                        </Col>
                                        <Col md={6}>
                                        <div className="mb-3">
                                            <Label htmlFor="lastname">Last Name<span className="text-danger px-1">*</span></Label>
                                            <Input
                                            type="text"
                                            name="lastname"
                                            id="lastname"
                                            placeholder="Enter your last name"
                                            value={formik.values.lastname}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.lastname && !!formik.errors.lastname}
                                            />
                                            <FormFeedback>{formik.errors.lastname}</FormFeedback>
                                        </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <Label htmlFor="email">Email<span className="text-danger px-1">*</span></Label>
                                            <Input
                                                type="email"
                                                name="email"
                                                id="email"
                                                placeholder="Enter your email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                invalid={formik.touched.email && !!formik.errors.email}
                                            />
                                            <FormFeedback>{formik.errors.email}</FormFeedback>
                                            </div>
                                        </Col>  
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <Label htmlFor="phone">Phone<span className="text-danger px-1">*</span></Label>
                                            <Input
                                                type="text"
                                                name="phone"
                                                id="phone"
                                                placeholder="Enter your phone number"
                                                value={formik.values.phone}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                invalid={formik.touched.phone && !!formik.errors.phone}
                                            />
                                            <FormFeedback>{formik.errors.phone}</FormFeedback>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="category">Category<span className="text-danger px-1">*</span></Label>
                                                <select
                                                    className={`form-control ${formik.touched.category && formik.errors.category ? "is-invalid" : ""}`}
                                                    name="category"
                                                    value={formik.values.category}
                                                    onChange={(e) => {
                                                        const selected = e.target.value;
                                                        formik.setFieldValue("category", selected);
                                                        const foundCat = categoryList.find(cat => cat.name === selected);
                                                        const subs = foundCat?.subcats || [];
                                                        setSubCategoryList(subs);
                                                        const firstSub = subs.length > 0 ? subs[0].name : "";
                                                        formik.setFieldValue("Subcategory", firstSub);
                                                    }}
                                                    >
                                                    {categoryList.map((cat) => (
                                                        <option key={cat.id} value={cat.name}>{cat.name}</option>
                                                    ))}
                                                </select>
                                                <FormFeedback>{formik.errors.category}</FormFeedback>
                                            </div>
                                            </Col>

                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="subcategory">Sub Category<span className="text-danger px-1">*</span></Label>
                                                <select
                                                className={`form-control ${formik.touched.Subcategory && formik.errors.Subcategory ? "is-invalid" : ""}`}
                                                name="Subcategory"
                                                value={formik.values.Subcategory}
                                                onChange={formik.handleChange}
                                                >
                                                {/* <option value="">Select</option> */}
                                                {subCategoryList.map((sub) => (
                                                    <option key={sub.id} value={sub.name}>{sub.name}</option>
                                                ))}
                                                </select>
                                                <FormFeedback>{formik.errors.Subcategory}</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md={12} className="d-flex justify-content-end">
                                            <Button type="submit" color="primary" className="w-md">
                                                UPDATE 
                                            </Button>
                                        </Col>
                                    </Row>
                                    </CardBody>
                                </Card>
                            </Col>                   
                        </Row>

                        {/* Professional Information Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Professional Information</p>
                                <p>Showcase your professional identity and credentials.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="business_name">Business/Professional Name</Label>
                                                    <Input
                                                        type="text"
                                                        name="business_name"
                                                        id="business_name"
                                                        placeholder="Enter your business or professional name"
                                                        value={formik.values.business_name}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="professional_title">Professional Title</Label>
                                                    <Input
                                                        type="text"
                                                        name="professional_title"
                                                        id="professional_title"
                                                        placeholder="e.g., CPA, Tax Advisor, Business Consultant"
                                                        value={formik.values.professional_title}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="business_logo">Business Logo</Label>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <input
                                                            type="file"
                                                            name="business_logo"
                                                            id="business_logo"
                                                            accept="image/*"
                                                            onChange={handleBusinessLogoChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        {(previewBusinessLogo || (formik.values.business_logo && typeof formik.values.business_logo === 'string' && formik.values.business_logo)) && (
                                                            <div className="position-relative" style={{ display: "inline-block" }}>
                                                                <img
                                                                    src={
                                                                        previewBusinessLogo
                                                                            ? previewBusinessLogo
                                                                            : typeof formik.values.business_logo === "string"
                                                                            ? `${baseUrl}${formik.values.business_logo}`
                                                                            : defaultUserImg
                                                                    }
                                                                    alt="Business Logo"
                                                                    style={{
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        objectFit: 'cover',
                                                                        borderRadius: '50%',
                                                                        border: '2px solid #dee2e6',
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.currentTarget.onerror = null;
                                                                        e.currentTarget.src = defaultUserImg;
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <Button 
                                                            type="button" 
                                                            color="primary" 
                                                            outline
                                                            onClick={() => document.getElementById('business_logo')?.click()}
                                                        >
                                                            Choose Business Logo
                                                        </Button>
                                                        {formik.values.business_logo instanceof File && (
                                                            <span className="text-muted">{formik.values.business_logo.name}</span>
                                                        )}
                                                    </div>
                                                    {formik.values.business_logo instanceof File && (
                                                        <small className="text-info d-block mt-1">
                                                            <i className="mdi mdi-information-outline"></i> Click UPDATE button to save the file
                                                        </small>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="resume">Resume/CV</Label>
                                                    <div>
                                                        <input
                                                            type="file"
                                                            name="resume"
                                                            id="resume"
                                                            accept=".pdf,.doc,.docx"
                                                            onChange={(e) => {
                                                                const file = e.target.files?.[0];
                                                                if (file) formik.setFieldValue("resume", file);
                                                            }}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <Button 
                                                            type="button" 
                                                            color="primary" 
                                                            outline
                                                            onClick={() => document.getElementById('resume')?.click()}
                                                        >
                                                            Choose Resume/CV
                                                        </Button>
                                                        {formik.values.resume instanceof File && (
                                                            <span className="ms-2 text-muted">{formik.values.resume.name}</span>
                                                        )}
                                                        {formik.values.resume && typeof formik.values.resume === 'string' && formik.values.resume && (
                                                            <div className="mt-2">
                                                                <small className="text-muted">Current resume: <a href={formik.values.resume} target="_blank" rel="noopener noreferrer">View Resume</a></small>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {formik.values.resume instanceof File && (
                                                        <small className="text-info d-block mt-1">
                                                            <i className="mdi mdi-information-outline"></i> Click UPDATE button to save the file
                                                        </small>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="certifications">Certifications</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="certifications"
                                                        id="certifications"
                                                        placeholder="e.g., CPA, EA, CFP, MBA (comma-separated)"
                                                        value={formik.values.certifications}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="licenses">Professional Licenses</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="licenses"
                                                        id="licenses"
                                                        placeholder="Enter your professional licenses"
                                                        value={formik.values.licenses}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="education_background">Education Background</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="education_background"
                                                        id="education_background"
                                                        placeholder="e.g., MBA from Harvard, BS in Accounting"
                                                        value={formik.values.education_background}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="years_of_experience">Years of Experience</Label>
                                                    <Input
                                                        type="number"
                                                        name="years_of_experience"
                                                        id="years_of_experience"
                                                        placeholder="Enter years"
                                                        value={formik.values.years_of_experience}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="expertise_level">Expertise Level</Label>
                                                    <Input
                                                        type="select"
                                                        name="expertise_level"
                                                        id="expertise_level"
                                                        value={formik.values.expertise_level}
                                                        onChange={formik.handleChange}
                                                    >
                                                        <option value="">Select Level</option>
                                                        <option value="beginner">Beginner</option>
                                                        <option value="intermediate">Intermediate</option>
                                                        <option value="advanced">Advanced</option>
                                                        <option value="expert">Expert</option>
                                                    </Input>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="business_introduction">About Yourself</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="business_introduction"
                                                        id="business_introduction"
                                                        placeholder="Tell potential clients about yourself and your services"
                                                        value={formik.values.business_introduction}
                                                        onChange={formik.handleChange}
                                                        rows={4}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Location & Service Areas Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Location & Service Areas</p>
                                <p>Where you're located and where you serve clients.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="address_line1">Address Line 1</Label>
                                                    <Input
                                                        type="text"
                                                        name="address_line1"
                                                        id="address_line1"
                                                        placeholder="Street address"
                                                        value={formik.values.address_line1}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="address_line2">Address Line 2</Label>
                                                    <Input
                                                        type="text"
                                                        name="address_line2"
                                                        id="address_line2"
                                                        placeholder="Apartment, suite, etc. (optional)"
                                                        value={formik.values.address_line2}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="city">City</Label>
                                                    <Input
                                                        type="text"
                                                        name="city"
                                                        id="city"
                                                        placeholder="City"
                                                        value={formik.values.city}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="state">State/Province</Label>
                                                    <Input
                                                        type="text"
                                                        name="state"
                                                        id="state"
                                                        placeholder="State"
                                                        value={formik.values.state}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="zipcode">Zip/Postal Code</Label>
                                                    <Input
                                                        type="text"
                                                        name="zipcode"
                                                        id="zipcode"
                                                        placeholder="Zip code"
                                                        value={formik.values.zipcode}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="country">Country</Label>
                                                    <Input
                                                        type="text"
                                                        name="country"
                                                        id="country"
                                                        placeholder="Country"
                                                        value={formik.values.country}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="timecode">Country Code</Label>
                                                    <Input
                                                        type="text"
                                                        name="timecode"
                                                        id="timecode"
                                                        placeholder="e.g., US, GB, CA"
                                                        value={selectedCode}
                                                        onChange={(e) => {
                                                            const code = e.target.value.toUpperCase();
                                                            setSelectedCode(code);
                                                            formik.setFieldValue('timecode', code);
                                                            // Filter timezones by code
                                                            if (code && timezone.length > 0) {
                                                                const filtered = timezone.filter((item: any) => item.code === code);
                                                                setFilteredTimezones(filtered);
                                                            } else {
                                                                setFilteredTimezones(timezone);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="timezone">Timezone</Label>
                                                    <Input
                                                        type="select"
                                                        name="timezone"
                                                        id="timezone"
                                                        value={formik.values.timezone}
                                                        onChange={(e) => {
                                                            formik.setFieldValue('timezone', e.target.value);
                                                            setSelectedTimezone(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">Please select timezone</option>
                                                        {filteredTimezones.map((tzItem: any) => (
                                                            <option key={tzItem.timezone} value={tzItem.timezone}>
                                                                {tzItem.timezone}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="buissness_phone">Business Phone</Label>
                                                    <Input
                                                        type="text"
                                                        name="buissness_phone"
                                                        id="buissness_phone"
                                                        placeholder="Business phone number"
                                                        value={formik.values.buissness_phone}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="service_areas">Service Areas</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="service_areas"
                                                        id="service_areas"
                                                        placeholder="e.g., Nationwide, California, New York, Texas, Remote only"
                                                        value={formik.values.service_areas}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Social Media & Online Presence Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Social Media & Online Presence</p>
                                <p>Link your professional profiles and websites.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="website">Website URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="website"
                                                        id="website"
                                                        placeholder="https://yourwebsite.com"
                                                        value={formik.values.website}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="linkedin_url">LinkedIn Profile URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="linkedin_url"
                                                        id="linkedin_url"
                                                        placeholder="https://linkedin.com/in/yourprofile"
                                                        value={formik.values.linkedin_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="facebook_url">Facebook Page/Profile URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="facebook_url"
                                                        id="facebook_url"
                                                        placeholder="https://facebook.com/yourpage"
                                                        value={formik.values.facebook_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="x_url">X (Twitter) Profile URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="x_url"
                                                        id="x_url"
                                                        placeholder="https://x.com/yourprofile"
                                                        value={formik.values.x_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="instagram_url">Instagram Profile URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="instagram_url"
                                                        id="instagram_url"
                                                        placeholder="https://instagram.com/yourprofile"
                                                        value={formik.values.instagram_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="youtube_url">YouTube Channel URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="youtube_url"
                                                        id="youtube_url"
                                                        placeholder="https://youtube.com/@yourchannel"
                                                        value={formik.values.youtube_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="professional_blog">Professional Blog URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="professional_blog"
                                                        id="professional_blog"
                                                        placeholder="https://yourblog.com (optional)"
                                                        value={formik.values.professional_blog}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="portfolio_url">Portfolio Website URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="portfolio_url"
                                                        id="portfolio_url"
                                                        placeholder="https://yourportfolio.com (optional)"
                                                        value={formik.values.portfolio_url}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Skills & Specializations Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Skills & Specializations</p>
                                <p>Highlight your expertise and specializations.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="specializations">Specializations</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="specializations"
                                                        id="specializations"
                                                        placeholder="e.g., Small Business Tax Planning, QuickBooks Setup, Financial Auditing"
                                                        value={formik.values.specializations}
                                                        onChange={formik.handleChange}
                                                        rows={3}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="languages_spoken">Languages Spoken</Label>
                                                    <Input
                                                        type="text"
                                                        name="languages_spoken"
                                                        id="languages_spoken"
                                                        placeholder="e.g., English, Spanish, French (comma-separated)"
                                                        value={formik.values.languages_spoken}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="tools">Professional Tools & Software</Label>
                                                    <Input
                                                        type="text"
                                                        name="tools"
                                                        id="tools"
                                                        placeholder="e.g., QuickBooks, Xero, ProConnect, TurboTax, Excel (comma-separated)"
                                                        value={formik.values.tools}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Client Focus & Experience Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Client Focus & Experience</p>
                                <p>Describe your target clients and industry experience.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="client_types">Types of Clients Served</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="client_types"
                                                        id="client_types"
                                                        placeholder="e.g., Small Business, Startups, Individuals, Corporations, Non-profits"
                                                        value={formik.values.client_types}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="industry_experience">Industry Experience</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="industry_experience"
                                                        id="industry_experience"
                                                        placeholder="e.g., Healthcare, Retail, Technology, Real Estate"
                                                        value={formik.values.industry_experience}
                                                        onChange={formik.handleChange}
                                                        rows={2}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Portfolio & Media Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Portfolio & Media</p>
                                <p>Showcase your work and achievements.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="profile_video">Introduction Video URL</Label>
                                                    <Input
                                                        type="url"
                                                        name="profile_video"
                                                        id="profile_video"
                                                        placeholder="https://youtube.com/watch?v=... or other video platform"
                                                        value={formik.values.profile_video}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="case_studies">Case Studies & Success Stories</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="case_studies"
                                                        id="case_studies"
                                                        placeholder="Describe notable case studies or success stories"
                                                        value={formik.values.case_studies}
                                                        onChange={formik.handleChange}
                                                        rows={4}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {/* Expert Tags Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Expert Tags</p>
                                <p>Add tags to help clients find you.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="expert_tags">Tags</Label>
                                                    <Input
                                                        type="text"
                                                        name="expert_tags"
                                                        id="expert_tags"
                                                        placeholder="e.g., Quick Response, 24/7 Available, Bilingual, Remote Only, Weekend Available (comma-separated)"
                                                        value={formik.values.expert_tags}
                                                        onChange={formik.handleChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={12} className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" className="w-md">
                                                    UPDATE 
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="border-bottom mb-4">
                        <Col md={4}>
                          <p className="mb-0 font-size-16 text-dark fw-medium">Change Password</p>
                          <p></p>
                        </Col>
                        <Col md={12}>
                          <Card className="rounded-4 border">
                            <CardBody className="p-4">
                              {/* <form onSubmit={formik.handleSubmit}> */}
                                <Row>
                                  {/* Current Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="currentPassword">
                                        Current Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showCurrent ? "text" : "password"}
                                          name="currentPassword"
                                          id="currentPassword"
                                          placeholder="Enter current password"
                                          value={formik.values.currentPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.currentPassword &&
                                            !!formik.errors.currentPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowCurrent(!showCurrent)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showCurrent ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                        <FormFeedback>{formik.errors.currentPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                   {/* New Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="newPassword">
                                        New Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showNew ? "text" : "password"}
                                          name="newPassword"
                                          id="newPassword"
                                          placeholder="Enter new password"
                                          value={formik.values.newPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.newPassword &&
                                            !!formik.errors.newPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowNew(!showNew)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showNew ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.newPassword}</FormFeedback>
                                      </InputGroup>
                                      <small className="text-muted d-block mt-1">
                                        <strong>Password Requirements:</strong>
                                        <ul className="mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                                          <li>At least 6 characters</li>
                                          <li>One uppercase letter (A-Z)</li>
                                          <li>One number (0-9)</li>
                                          <li>One special character (!@#$%^&*...)</li>
                                        </ul>
                                      </small>
                                    </div>
                                  </Col>
                                  {/* Confirm Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="confirmPassword">
                                        Confirm Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showConfirm ? "text" : "password"}
                                          name="confirmPassword"
                                          id="confirmPassword"
                                          placeholder="Confirm new password"
                                          value={formik.values.confirmPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.confirmPassword &&
                                            !!formik.errors.confirmPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowConfirm(!showConfirm)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showConfirm ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.confirmPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button onClick={handlePasswordUpdate} color="primary" className="w-md">
                                      Update Password
                                    </Button>
                                  </Col>
                                </Row>
                              {/* </form> */}
                            </CardBody>
                          </Card>
                        </Col>
                        </Row>

                        {/* Stripe Connect Status Section */}
                        <Row className="border-bottom mb-4">
                            <Col md={3}>
                                <p className="mb-0 font-size-16 text-dark fw-medium">Stripe Connect</p>
                                <p>Manage your payment account setup.</p>
                            </Col>
                            <Col md={9}>
                                <Card className="rounded-4 border">
                                    <CardBody className="p-4">
                                        {stripeConnectStatus && (
                                            <div>
                                                <div className="mb-3">
                                                    <Label className="fw-medium">Status:</Label>
                                                    <span className={`ms-2 badge ${stripeConnectStatus.is_onboarded ? 'bg-success' : stripeConnectStatus.onboarding_status === 'in_progress' ? 'bg-warning' : 'bg-secondary'}`}>
                                                        {stripeConnectStatus.is_onboarded 
                                                            ? 'Connected' 
                                                            : stripeConnectStatus.onboarding_status === 'in_progress' 
                                                            ? 'Onboarding in Progress' 
                                                            : 'Not Connected'}
                                                    </span>
                                                </div>
                                                {stripeConnectStatus.stripe_account_id && !stripeConnectStatus.is_onboarded && (
                                                    <div className="mt-3">
                                                        <Button 
                                                            color="primary" 
                                                            onClick={handleStripeConnectOnboard}
                                                            disabled={isLoadingStripeLink}
                                                        >
                                                            {isLoadingStripeLink ? 'Creating Link...' : 'Update Account Details'}
                                                        </Button>
                                                        <p className="text-muted mt-2 mb-0 small">
                                                            Click to update your Stripe Connect account details. This will open in a new tab.
                                                        </p>
                                                    </div>
                                                )}
                                                {!stripeConnectStatus.stripe_account_id && (
                                                    <div className="mt-3">
                                                        <Button 
                                                            color="primary" 
                                                            onClick={handleStripeConnectOnboard}
                                                            disabled={isLoadingStripeLink}
                                                        >
                                                            {isLoadingStripeLink ? 'Creating Link...' : 'Connect Stripe Account'}
                                                        </Button>
                                                        <p className="text-muted mt-2 mb-0 small">
                                                            Click to start the Stripe Connect onboarding process. This will open in a new tab.
                                                        </p>
                                                    </div>
                                                )}
                                                {stripeConnectStatus.is_onboarded && (
                                                    <div className="mt-3">
                                                        <div className="mb-2">
                                                            <p className="text-success mb-2">
                                                                <i className="bx bx-check-circle me-1"></i>
                                                                Your Stripe account is connected and ready to receive payments.
                                                            </p>
                                                        </div>
                                                        <Button 
                                                            color="secondary" 
                                                            onClick={handleStripeConnectOnboard}
                                                            disabled={isLoadingStripeLink}
                                                        >
                                                            {isLoadingStripeLink ? 'Creating Link...' : 'Update Account Details'}
                                                        </Button>
                                                        <p className="text-muted mt-2 mb-0 small">
                                                            Click to update your Stripe Connect account information. This will open in a new tab.
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {!stripeConnectStatus && (
                                            <div>
                                                <p className="text-muted">Loading Stripe Connect status...</p>
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                        <Row className="border-bottom">
                            <Col>
                                <p className="mb-3 font-size-16 text-dark fw-medium">Two-factor authentication</p>
                                {!is_two_fact_status && step !== 1 && step !== 4  &&(
                                    <div className="mb-3">
                                        <p className="mb-1">Two-factor authentication is disable
                                        </p>
                                        <p>For enhanced security, please enable two-factor authentication (2FA) using an authenticator app such as Microsoft Authenticator or Google Authenticator.</p>
                                        <button className="btn btn-primary btn-sm"  type="button" onClick={toggletwofactauth} >Enable Two Factor
                                        </button>
                                    </div>
                                )}

                                {/* {is_two_fact_status  &&( */}
                                {is_two_fact_status && step !== 2  && step !==3 &&(
                                    <div className="mb-3">
                                        <p>Two-factor authentication is enabled.
                                        </p>
                                        <button className="btn btn-primary btn-sm" type="button" onClick={() => setStep(3)} >Disable Two-Factor Authentication
                                        </button>
                                    </div>
                                )}

                                { step === 3 &&(
                                    <Col md={6}>
                                        <Label htmlFor="lastname">Enter the code from your authenticator app to disable Two-Factor Authentication, or use your recovery code if you no longer have access to the app.<span className="text-danger px-1">*</span></Label>
                                        <Input
                                        type="text"
                                        id="disableotp"
                                        name="disableotp"
                                        value={disableotp}
                                        onChange={disableotpchnage}
                                        placeholder="Enter 6-digit code"
                                        maxLength={6}
                                        onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // stops form submit
                                        }
                                        }}
                                        />
                                        <button className="btn btn-primary btn-sm mt-2 mb-2" type="button"  onClick={verify_disable_otp}>Continue</button>
                                    </Col>
                                )}
                                {secretkey  &&(
                                    <div className="mb-3">
                                        <p>Enable Two-Factor Authentication by scanning the QR code with an authenticator app such as Google Authenticator or Microsoft Authenticator to generate secure one-time passcodes.</p>
                                        <p>Your Secret Key is : <strong>{secretkey}</strong></p>
                                    </div>
                                )}

                                {step === 1 &&(
                                    <div className="mb-3">
                                        <img  src={`data:image/png;base64,${qrImage}`}
                                        alt="QR Code" className="border" style={{ width: "200px", height: "200px" }} 
                                        />
                                        <p >If you can’t scan the QR code, enter the secret key manually in your authenticator app to generate secure one-time passcodes.</p>
                                    </div>
                                )}


                                {step === 1 &&(
                                    <div className="mb-3">
                                        <Label htmlFor="lastname">Enter the code from your authenticator app<span className="text-danger px-1">*</span></Label>
                                        <Input
                                        type="text"
                                        id="otp"
                                        name="otp"
                                        value={otp}
                                        onChange={handleotpchnage}
                                        placeholder="Enter 6-digit code"
                                        maxLength={6}
                                        onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // stops form submit
                                        }
                                        }}
                                        />
                                        <div className="d-flex gap-1 align-items-center">
                                            <button className="btn btn-primary btn-sm" type="button" onClick={verify_two_fact}>Continue</button><br/><br />
                                            {/* <button className="btn btn-secondary btn-sm" type="button" onClick={() => setStep(4)}>Other Method</button> */}
                                        </div>
                                    </div>
                                )}
                                {/* { step === 4 &&(
                                <div className="mb-3">
                                    <p >If you can’t scan the QR code, enter the secret key manually in your authenticator app to generate the code.</p>
                                    <Label htmlFor="lastname">Enter the code from your authenticator app<span className="text-danger px-1">*</span></Label>
                                    <Input
                                    type="text"
                                    id="otp"
                                    name="otp"
                                    value={otp}
                                    onChange={handleotpchnage}
                                    placeholder="Enter otp"
                                    maxLength={6}
                                    />
                                    <button className="btn btn-primary btn-sm mt-2" type="button"  onClick={verify_two_fact}>Continue</button>
                                </div>
                                )} */}

                            </Col>

                            {step === 2 &&(
                            <div className="mb-3">
                                <h3>Save Your Recovery Codes</h3>
                                <ul className="ps-0">
                                {recoverykey.map((key, index) =>(
                                    <li className="mb-1" key={index}>{key}</li>
                                ))}
                                </ul>
                                <div className="d-flex align-items-center gap-1">
                                    <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                    const content = recoverykey.join("\n");
                                    const blob  = new Blob([content], {type : "text/plain"});
                                    const link = document.createElement('a');
                                    link.href = URL.createObjectURL(blob)
                                    link.download = "recovery-key.txt";
                                    link.click()
                                    }}>Download Recovery Codes</button>
                                    <button className="btn btn-secondary btn-sm" type="button" onClick={() => setmodal_center(true)} >Next</button>
                                </div>
                            </div>
                            )}

                            <Modal
                                isOpen={modal_center}
                                centered
                                className="rounded-4">
                                <ModalHeader className="py-3 px-4" >
                                <div className="modal-title mt-0 font-size-16 text-dark">
                                    Two-Factor Authentication Enabled
                                </div>
                                </ModalHeader>
                                <div className="p-6">
                                    <Row>
                                    {/* <h2>Two factor Authentication is now enable in your account</h2> */}
                                    <p>Your account is now protected with two-factor authentication.The setup is complete, and your login is more secure.</p>
                                    <div className="d-flex justify-content-start">
                                        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Done</button>
                                    </div>
                                    </Row>
                                </div>
                            </Modal>
                        </Row>

                    
                    </Form>
                </CardBody>
                </Card>
            </Col>
            </Row>
        </CardBody>
        </Card>

        </Container>
    </div>
    </React.Fragment>
);
};

export default Exp_profile;
